import cn from 'classnames';
import styles from './PaginationRoutes.module.scss';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { parseText } from '@/utils/parseText';
import { useTranslations } from '@/hooks/useTranslations';

type PaginationRoutesProps = {
  routes: {
    link: string;
    text: string;
  }[];
  className?: string;
};

export function PaginationRoutes({ routes, className }: PaginationRoutesProps) {
  const router = useRouter();
  const paginationClassName = cn(styles.pagination, className);
  const translations = useTranslations();

  const handleRouteClick = (link: string) => {
    if (
      router.asPath === link ||
      `${router.asPath}/` === link ||
      router.asPath.split('?')[0] === link
    ) {
      return;
    }

    if (Object.values(router.query)[0] === link) {
      return;
    }

    router.push(link);
  };

  return (
    <div className={paginationClassName}>
      <Link className={styles.route} href={'/'}>
        {translations.home}{' '}
      </Link>
      {routes.map((route) => (
        <span
          key={route.text}
          onClick={() => handleRouteClick(route.link)}
          className={`${styles.route} ${
            router.asPath === route.link || `${router.asPath}/` === route.link
              ? styles.nonClick
              : ''
          }`}
        >
          {' '}
          / {parseText(route.text)}
        </span>
      ))}
    </div>
  );
}
